// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"520":"78d56269","815":"f4a3e419"}[chunkId] + ".js";
};